import React from "react";
import { useSearchParams } from "react-router-dom";

import CustomTabPanel from "components/Shared/CustomTabPanel";
import CustomTabs from "components/Shared/CustomTabs";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";
import NoteTab from "../../../Note/Notetab";

import { useGetNotesBySourceQuery } from "store/services/noteApi";

import { useGetDocumentsBySourceQuery } from "store/services/documentApi";
import DocumentsTab from "../../../Document/DocumentTab";

import { useCocCollectionDetailContext } from "contexts/PaymentContexts/CocCollectionContext";
import CocCollectionShipmentList from "./CocCollectionShipmentList";
import { CocCollectionPaymentDetailTab } from "./CocCollectionPaymentDetailTab";

const CocCollectionDetailTab = () => {
  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "note";

  const { CocCollectionDetail } = useCocCollectionDetailContext();

  // Fetch notes to get the count for the badge
  const { data: notes } = useGetNotesBySourceQuery(
    { source: "COCCollection", sourceRef: CocCollectionDetail?._id },
    { skip: !CocCollectionDetail?._id }
  );

  // Fetch documents to get the count for the badge
  const { data: documents } = useGetDocumentsBySourceQuery(
    { source: "COCCollection", sourceRef: CocCollectionDetail?._id },
    { skip: !CocCollectionDetail?._id }
  );

  const hasPaymentDetails = CocCollectionDetail?.paymentDetails &&
    typeof CocCollectionDetail.paymentDetails === 'object' &&
    Object.keys(CocCollectionDetail.paymentDetails).length > 0;

  const tabs = [
    {
      label: "Note",
      value: "note",
      badgeCount: notes?.length || 0,
    },
    { label: "Document", value: "document", badgeCount: documents?.totalItems },

    {
      label: "Shipment",
      value: "shipment",
      badgeCount: CocCollectionDetail?.shipmentId?.length,
    },
    ...(hasPaymentDetails
      ? [{
        label: "Payment",
        value: "payment",
      }]
      : []
    ),
  ];
  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {CocCollectionDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="note">
            <NoteTab source="CocCollection" sourceRef={CocCollectionDetail._id} />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="document">
            <DocumentsTab
              source="CocCollection"
              sourceRef={CocCollectionDetail._id}
            />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="shipment">
            <CocCollectionShipmentList />
          </CustomTabPanel>
          {hasPaymentDetails && (
            <CustomTabPanel activeTab={activeTab} value="payment">
              <CocCollectionPaymentDetailTab />
            </CustomTabPanel>
          )}
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default CocCollectionDetailTab;
